import React from "react";
import "./Index.css";

import Img1 from "../Img/Main Img.png";
import PDF from "../Data/my-cv.pdf";

import {
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  GithubOutlined,
  DownloadOutlined,
  CaretRightOutlined,
} from "@ant-design/icons";
import { message } from "antd";

export default function Index() {
  const [messageApi, contextHolder] = message.useMessage();
  const success = () => {
    messageApi
      .open({
        type: "loading",
        content: "Downloading..",
        duration: 2.5,
      })
      .then(() => {
        const link = document.createElement("a");
        link.href = PDF;
        link.download = "my-cv.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success("Download successful", 2.5);
      });
  };
  const error = () => {
    messageApi.open({
      type: 'error',
      content: 'Coming soon..',
    });
  };
  return (
    <div className="Index-Body">
      {contextHolder}
      <div className="Index-Left">
        <p className="Index-Text1">
          Hello! I&apos;m
          <br />
          Tasnim Shahriar Akash
        </p>
        <p className="Index-Text2">
          Software engineer specializing in MERN Stack.
        </p>

        <button className="Index-Left-Button" onClick={success}>
          Get My-CV
          <DownloadOutlined />
        </button>

        <div className="Index-Left-Div">
          <button className="Index-Left-Button2" onClick={error}>
            <CaretRightOutlined />
          </button>
          <p className="Index-Text3">Watch Video</p>
        </div>



        
      </div>
      <div className="Index-Right">
        <img className="Index-Img" src={Img1} alt="" />
        <div className="Index-round-line1" />
        <div className="Index-round-line2" />
        <div className="Index-round-line3" />
        <a
          href="https://www.facebook.com/tasnimSakash/"
          target="blank"
          className="Index-A-Tag1"
        >
          <FacebookOutlined />
        </a>

        <a
          href="https://www.instagram.com/tasnim_shahriar_akash?utm_source=qr%2F"
          target="blank"
          className="Index-A-Tag2"
        >
          <InstagramOutlined />
        </a>

        <a
          href="https://www.linkedin.com/in/tasnimsakash/"
          target="blank"
          className="Index-A-Tag3"
        >
          <LinkedinOutlined />
        </a>

        <a
          href="https://github.com/akashsdk"
          target="blank"
          className="Index-A-Tag4"
        >
          <GithubOutlined />
        </a>
      </div>
    </div>
  );
}
